import axios from 'axios';
import { getToken } from '../auth';

const cooperplaceApi = axios.create({
  baseURL: import.meta.env.VITE_COOPERPLACE_API_URL,
});

cooperplaceApi.interceptors.request.use(config => {
  const outputConfig = config;

  const token = getToken();
  if (token) {
    outputConfig.headers.Authorization = `Bearer ${token}`;
  }

  return outputConfig;
});

export async function postMicrosoftLogin(idToken) {
  try {
    const { data } = await cooperplaceApi.post('sessions/login/microsoft', { idToken });
    return data;
  } catch (ex) {
    const status = ex?.response?.status;
    const message = ex?.response?.data?.error || ex?.response?.data?.message;

    const error = new Error(
      message || 'Não foi possível autenticar com a Microsoft. Tente novamente.'
    );
    error.status = status;
    throw error;
  }
}

export default cooperplaceApi;
